import { opService } from '@/lib/request';

/**
 * op 请求统一封装
 * 返回的 Promise：业务成功 resolve(data)，业务失败/异常 reject
 * op 接口响应为平铺结构：{ code, message, data }
 * @param {string} url 请求地址
 * @param {object} data 请求参数
 * @returns {Promise}
 */
export function opRequest(url, data) {
  return new Promise((resolve, reject) => {
    opService
      .post(url, data)
      .then(res => {
        if (res && +res.code === 0) {
          resolve(res.data);
        } else {
          reject(res);
        }
      })
      .catch(err => reject(err));
  });
}
